// extracted by mini-css-extract-plugin
export default {"field":"TasksGroupIcon_field__lmeRg","icon":"TasksGroupIcon_icon__Jcaid","outer":"TasksGroupIcon_outer__q5TK7","withName":"TasksGroupIcon_withName__A47P-"};